import { AutoComplete } from '../NarusMaterial'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const IGAOActionsAutocompleteField = props => {
  const { list, label, value, onChange, onSubmit, errors, ...rest } = props
  const dataFunc = text =>
    Promise.resolve(
      Object.values(list).filter(a => a.description.indexOf(text) >= 0)
    )

  const textFunc = v => v.description

  const handle = (v, isSubmit) => {
    if (onChange) {
      if (v && 'freetext' in v) {
        if (v.freetext.length === 0) {
          onChange(null)
        } else {
          onChange(
            {
              description: v.freetext,
              id: 'FREETEXT'
            },
            () => isSubmit && onSubmit && onSubmit()
          )
        }
      } else if (v) {
        onChange(v, () => isSubmit && onSubmit && onSubmit())
      } else {
        onChange(null)
      }
    }
  }

  function handleSubmit (e) {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form onSubmit={handleSubmit}>
      <AutoComplete
        {...rest}
        freetext
        label={label}
        dataFunc={dataFunc}
        textFunc={textFunc}
        errors={errors}
        value={value}
        onChange={handle}
        onChangeText={handle}
      />
      <button
        type='submit'
        hidden
      />
    </form>
  )
}
export const IGAOActionsAutocompleteInput = makeAutobindedInput(
  makeValidatedInput(IGAOActionsAutocompleteField)
)
